import MBoxClamp from './box-clamp.vue'
export default MBoxClamp
